// extracted by mini-css-extract-plugin
module.exports = {"section_title":"NotificationSectionTitle_section_title__1S691","icon":"NotificationSectionTitle_icon__3-eij","title":"NotificationSectionTitle_title__2Bm5l"};